import mustache from 'mustache'
import lodashEscape from 'lodash/escape'

export type CoreMustacheRenderers = Record<
  string,
  string | (() => (text: string, render: (s: string) => string) => string)
>

export interface MustacheRendererProps {
  /**
   * This will be the HTML tag that wraps the content. This is necessary because you cannot use dangerouslySetInnerHTML on a Fragment
   */
  readonly tagName: any

  /**
   * The mustache template string
   */
  readonly template: string

  /**
   * Optional custom views
   */
  readonly views?: any

  readonly truncate?: number
}

interface RenderTemplateArgs {
  template: string
  views: any
  coreMustacheRenderers: CoreMustacheRenderers
}

export const escapeAndRenderTemplate = ({
  template,
  views,
  coreMustacheRenderers
}: RenderTemplateArgs) => {
  /**
   * Escape the template *before* rendering with mustache, so we can display XSS attack
   * payloads without being vulnerable to the attack.
   */
  const doEscape = /[<>]/.test(template)
  const toRender = doEscape ? lodashEscape(template) : template
  return mustache.render(toRender, {
    ...views,
    ...coreMustacheRenderers
  })
}
